import React, { useContext, useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { checkOfficeTag, IsReeltimeTag } from '../../../../utils/helpers/checkOfficeTag';
import { Column, BaseRow, UserRow } from './UserRow';

//GraphQL
import { useLazyQuery, useQuery } from '@apollo/client';
import { getAdminClient } from '../AdminApolloClient';
import { SEARCH_OPTION_QUERY } from '../../../../../client/__graphql__/queries/user/getUserSearchOptions';
import { USER_ITEMS } from '../../../../../client/__graphql__/queries/user/getUserItems';
import { useParams } from 'react-router';

const client = getAdminClient();

export const UserList = () => {
    const params = useParams<{ kontor: string }>();

    const { data: searchOptions, loading: searchOptionsLoading } = useQuery(SEARCH_OPTION_QUERY, {
        skip: !IsReeltimeTag(params?.kontor),
        fetchPolicy: 'network-only',
        client: client,
        onCompleted: ((data: any) => {
            getUsers({
                variables: {
                    input: null
                }
            })
        })
    });

    const [getUsers, {data: users, loading: usersLoading} ] = useLazyQuery(USER_ITEMS, {
        fetchPolicy: 'network-only',
        client: client,
    });

    return (
        <>
        <Wrapper>
            {users?.getUserItems && users?.getUserItems?.length > 0 ? 
            <DataList>
                <RowHeader>
                    <Column><span>Epost</span></Column>
                    <Column><span>Rolle</span></Column>
                    <Column><span>Tilgang</span></Column>
                </RowHeader>
                {users?.getUserItems?.map((item:any, index:number) => {
                    return (<UserRow key={`user_${index}`} id={item?.id} email={item?.email} role={item?.role} canAccess={item?.canAccess} />);
                })}
            </DataList> : null }
        </Wrapper>
        </>
    );
};

export default UserList;

const DataList = styled.div`
    max-width: 800px;
    margin:auto;
`;

const Wrapper = styled.div`
    margin: 3em 0;
`;

const RowHeader = styled(BaseRow)`
    background-color: #110508;
    border-radius: 4px;
`;